function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "6C20A379-E7DA-4F19-8960-575749D28831");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "HOME",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FOOTER_DESKTOP",
  transform: "translate(-538.000000, -33.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 0.705882353
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-18",
  transform: "translate(539.000000, 34.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.015339274,35.4230831 L30.3033106,35.4230831 C30.3033106,35.4230831 31.3291121,22.9552953 15.1593252,22.9552953 C-1.01046173,22.9552953 0.015339274,35.4230831 0.015339274,35.4230831 Z",
  id: "Path-2124"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval-194",
  cx: 15.6396396,
  cy: 9.72972973,
  rx: 9.77477477,
  ry: 9.72972973
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.481982,15.5675676 C22.481982,15.5675676 27.3693694,16.5405405 29.3243243,12.6486486 C31.2792793,8.75675676 30.3018018,3.89189189 30.3018018,3.89189189",
  id: "Path-2125",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-221",
  fill: "#E63C27",
  x: 17.5945946,
  y: 11.6756757,
  width: 7.81981982,
  height: 7.78378378,
  rx: 3.89189189
}))));

var SvgEroskiContacto = function SvgEroskiContacto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "37px",
    viewBox: "0 0 32 37",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiContacto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-contacto.0ca33d59.svg";
export { ForwardRef as ReactComponent };